import {HttpClient, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "@env/environment";
import {GenericService} from "@ui-kit/framework/common/generic.service";
import {Observable} from "rxjs";
import {DailyTransactionsSummary, GenericChart, RetailerBatchSummary, TransactionsSummary} from "./transactions.model";

@Injectable({
  providedIn: 'root'
})
export class TransactionsService extends GenericService<DailyTransactionsSummary> {

  constructor(http: HttpClient) {
    super(http, environment.apiTransactHost + `/console/offering/district/accounts`);
  }

  getTransactionSchedule(params?: {name: string, val: any}[]): Observable<TransactionsSummary[]> {
    let requestParams = new HttpParams();
    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {requestParams = requestParams.append(ea.name, ea.val)});
    }
    return this.http.get<TransactionsSummary[]>(this.getBaseUrl + `/transactions/schedule`, {params: requestParams})
  }

  getDailyTransactionChartData(params?: {name: string, val: any}[]): Observable<GenericChart> {
    let requestParams = new HttpParams();
    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {requestParams = requestParams.append(ea.name, ea.val)});
    }
    return this.http.get<GenericChart>(this.getBaseUrl + `/transactions/summary/chart`, {params: requestParams})
  }

  getPayoutHistoryForDateRange(params?: {name: string, val: any}[]) {
    let requestParams = new HttpParams();
    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {requestParams = requestParams.append(ea.name, ea.val)});
    }
    return this.http.get<RetailerBatchSummary[]>(this.getBaseUrl + `/payout-history/payout-summary`, {params: requestParams})
  }

  getPayoutHistoryForBatchDateRange(url: string, params: {name: string, val: any}[]) {
    let requestParams = new HttpParams();
    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {requestParams = requestParams.append(ea.name, ea.val)});
    }
    return this.http.get<RetailerBatchSummary[]>(this.getBaseUrl + url, {params: requestParams})
  }

  getAllForDateRange(params?: {name: string, val: any}[]) {
    let requestParams = new HttpParams();
    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {requestParams = requestParams.append(ea.name, ea.val)});
    }
    return this.http.get<DailyTransactionsSummary[]>(this.getBaseUrl + `/transactions/summary`, {params: requestParams})
  }

  get getBaseUrl(): string {
    return environment.apiTransactHost + `/console/offering/district/accounts`;
  }
}
